import { cn } from '@duck/ui'

const SkeletonBar = ({
  width = 'w-full',
  height = 'h-4',
  className = '',
}: {
  width?: string
  height?: string
  className?: string
}) => (
  <div className={cn('bg-secondary/20 rounded animate-pulse', width, height, className)} />
)

export const ReleaseNotesTimelineSkeleton = () => {
  return (
    <div className="space-y-10">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index}>
          {/* Date row with dot */}
          <div className="flex items-center gap-3 mb-4">
            <SkeletonBar width="w-32" height="h-3" className="whitespace-nowrap" />
            <div className="h-2.5 w-2.5 rounded-full bg-muted-foreground/40 animate-pulse" />
            <div className="flex-1 h-px bg-border" />
          </div>

          {/* Single note card skeleton */}
          <div className="space-y-5 relative">
            <div className="border border-border bg-card rounded-lg p-6">
              {/* Title & labels row */}
              <div className="flex items-center justify-between mb-3">
                <div className="space-y-2">
                  <SkeletonBar width="w-2/3" height="h-5" />
                  <SkeletonBar width="w-1/3" height="h-4" />
                </div>
                <div className="flex gap-2">
                  <SkeletonBar width="w-16" height="h-6" className="rounded-full" />
                  <SkeletonBar width="w-16" height="h-6" className="rounded-full" />
                </div>
              </div>

              {/* Body preview */}
              <div className="space-y-2 mb-4">
                <SkeletonBar />
                <SkeletonBar width="w-5/6" />
                <SkeletonBar width="w-2/3" />
              </div>

              {/* Footer actions */}
              <div className="flex items-center justify-between">
                <SkeletonBar width="w-24" height="h-4" />
                <div className="flex gap-2">
                  <SkeletonBar width="w-20" height="h-8" className="rounded-md" />
                  <SkeletonBar width="w-20" height="h-8" className="rounded-md" />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

